<template>
  <RouterLink :to="{ name: routeName, params: { [slugKey]: slug } }" class="card-article__item">
    <section class="card-article__type">
      <span v-if="tag" class="tag -float -small">
        <SvgIcon :id="icon" />
        {{ tag }}
      </span>
    </section>

    <div class="card-article__figure" :style="{ backgroundImage: `url('/images/brand/placeholder.png')` }">
      <figure class="card-article__image" :style="{ backgroundImage: `url('${image}')` }" />
    </div>

    <section class="card-article__content">
      <div class="card-article__uptitle">
        <div class="card-article__data">
          <SvgIcon id="content-date" />
          <p>{{ formattedDate }}</p>
        </div>

        <div class="card-article__data">
          <SvgIcon id="time" />
          <p>{{ readingTime }} min</p>
        </div>
      </div>

      <h4 class="card-article__title">
        {{ title }}
      </h4>
    </section>
  </RouterLink>
</template>

<script>
import moment from 'moment'
import { getReadingTime } from '@/helpers/content-formatting'
import { typeTagMap, typeIconMap } from '@/helpers/type-maps'

export default {
  name: 'DemoGridArticlesSingle',
  props: {
    type: String,
    routeName: String,
    slug: String,
    slugKey: String
  },
  data() {
    return {
      typeTagMap,
      typeIconMap
    }
  },
  computed: {
    publication() {
      return this.$wp.allPublications[this.slug] || {}
    },
    title() {
      return this.publication.shortTitle || this.publication.title
    },
    tag() {
      return this.typeTagMap[this.type] || null
    },
    icon() {
      return this.typeIconMap[this.type] || null
    },
    formattedDate() {
      return this.publication && this.publication.original_publish_date
        ? moment(this.publication.original_publish_date).format('D MMMM YYYY')
        : null
    },
    image() {
      if (this.publication.featuredImage) return this.publication.featuredImage
      if (!this.publication.images || !this.publication.images.length) return '/images/brand/placeholder.png'

      const [image1, image2 = null] = this.publication.images
      return image1 || image2
    },
    readingTime() {
      return this.publication && getReadingTime(this.publication.content)
    }
  },
  methods: {
    getTypeQuery(type) {
      const query = { ...this.$route.query, type }
      return { query }
    }
  }
}
</script>
